import { Dispatch } from "redux";
import { ConsultarDiaUtilResponse } from "requests/feriados-nacionais";
import { addAlert } from "store/modules/snackBar";

export function validarDiaUtil(
    dispatch: Dispatch,
    response: ConsultarDiaUtilResponse
) {
    if (!response.diaUtil) {
        const formattedDate = new Intl.DateTimeFormat('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).format(new Date(response.proximoDiaUtil!));

        dispatch(
            addAlert({
                message: `O dia informado não é um dia útil - Próximo dia útil: ${formattedDate}`,
                severity: 'error',
            })
        );
    }

    return response.diaUtil;
}